export default __webpack_public_path__ + "static/media/1-3.6245b878.PNG";